/**
 =========================================================
 * Material Dashboard 2 React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import {forwardRef} from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Custom styles for MDInput
import MDInputRoot from "./MDInputRoot";

const MDInput = forwardRef(
    ({error, success, disabled, login, customHeight, type, ...rest}, ref) => (
        <MDInputRoot
            FormHelperTextProps={{
                className: "ErrorFormHelperTextProps",
            }}
            {...rest}
            ref={ref}
            type={type}
            
            onWheel={(e) => type == "number" ? e.target.blur() : e}

            ownerState={{error, success, disabled, login}}
            InputLabelProps={login == true ? {
                style: {
                    fontSize: 20,
                    // height: "100%"
                }
            } : {
                style: {
                    fontSize: 22,
                    background:"white",
                    borderRadius:"10px",
                    color:"black"
                }
            }}
            inputProps={login == true ? ({
                style: {
                    height: "50px",
                    fontSize: "20px",
                    direction: "rtl"
                },
            }) : {
                style: {
                    height: customHeight ?? "28px",
                    fontSize: "18px",
                    direction: "rtl"
                },
            }}
        />
    )
);

// Setting default values for the props of MDInput
MDInput.defaultProps = {
    error: false,
    success: false,
    disabled: false,
    login: false
};

// Typechecking props for the MDInput
MDInput.propTypes = {
    error: PropTypes.bool,
    success: PropTypes.bool,
    disabled: PropTypes.bool,
    login: PropTypes.bool,
};

export default MDInput;
